import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { filter, takeUntil } from "rxjs/operators";

/** Route path alone: the query string is filter state, not a different page. */
const pagePathOf = (router: Router, url: string): string => {
  const tree = router.parseUrl(url);
  tree.queryParams = {};
  tree.fragment = null;
  return tree.toString();
};

/**
 * Cancels in-flight GETs on navigation so a slow list never blocks the next screen. Writes are never cancelled
 * (the server may have applied them); assets (i18n, static json) are app-wide and kept.
 */
export const cancelOnNavigationInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== "GET" || req.url.includes("/assets/")) {
    return next(req);
  }

  const router = inject(Router);
  const ownerPath = pagePathOf(router, router.getCurrentNavigation()?.finalUrl?.toString() ?? router.url);

  const navigatedAway$ = router.events.pipe(
    filter((event): event is NavigationStart => event instanceof NavigationStart && router.navigated),
    filter((event) => pagePathOf(router, event.url) !== ownerPath),
  );
  return next(req).pipe(takeUntil(navigatedAway$));
};
